import { IconCaretRight, IconInfoSparkle } from "@teral/icons";
import type React from "react";
import { InfoHoverCard } from "../../info-hover-card";

type SearchExampleTooltipProps = {
  onSelectExample: (query: string) => void;
  exampleQueries?: string[];
};

export const SearchExampleTooltip: React.FC<SearchExampleTooltipProps> = ({
  onSelectExample,
  exampleQueries,
}) => {
  const examples = exampleQueries ?? [
    "Show failed requests today",
    "auth errors in the last 3h",
    "API calls from a path that includes /api/v1/oz",
  ];

  return (
    <InfoHoverCard
      content={
        <div>
          <div className="font-medium mb-2 flex items-center gap-2 text-sm">
            <span>Try queries like:</span>
            <span className="text-2xs text-gray-11">(click to use)</span>
          </div>
          <ul className="space-y-1.5 pl-1 [&_svg]:size-[10px] ">
            {examples.map((example) => (
              <li key={example} className="flex items-center gap-2">
                <IconCaretRight className="text-gray-9" />
                <button
                  type="button"
                  className="hover:text-gray-11 transition-colors cursor-pointer hover:underline"
                  onClick={() => onSelectExample(example)}
                  data-testid={`example-${example}`}
                >
                  "{example}"
                </button>
              </li>
            ))}
          </ul>
        </div>
      }
      delayDuration={150}
    >
      <div data-testid="info-icon">
        <IconInfoSparkle className="size-4 text-gray-9" />
      </div>
    </InfoHoverCard>
  );
};
